/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2019/3/13
 * Time: 11:39
 * Desc:
 */

/**
 * @desc 获取cookie
 * @param name cookie的key
 * @returns {string}
 */
export const getCookie = (name) => {
  var arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split("=");
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return "";
};

/**
 * 设置cookie
 * @param name cookie的key
 * @param value cookie的value
 * @param expiredays 设置过期时间
 * @param domain 所在域
 * @param path 路径
 */
export const setCookie = (name, value, expiredays, domain, path) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    (domain ? "; domain=" + domain : "") +
    (path ? "; path=" + path : "");
};
// export const setCookie=(name, value, expires, path, domain, secure)=>{
//     var cookieText = encodeURIComponent(name) + '=' + encodeURIComponent(value);
//     if (expires instanceof Date) {
//         cookieText += '; expires=' + expires;
//     }
//     if (path) {
//         cookieText += '; expires=' + expires;
//     }
//     if (domain) {
//         cookieText += '; domain=' + domain;
//     }
//     if (secure) {
//         cookieText += '; secure';
//     }
//     // 添加cookie的原生方法
//     document.cookie = cookieText;
// }

/**
 * @desc 删除cookie
 * @param name cooie的key
 */
export const delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  console.log(cval, name, "00000");
  if (cval != null) {
    // document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    console.log(document.cookie, "00000");
  }
};

/**
 * @desc 获取url参数
 * @param {String} name  想要获取的参数名字
 */
export const getQueryString = (name) => {
  const fullUrl = window.location.href;
  const hashIndex = fullUrl.indexOf('#');
  
  let searchPart = '';
  let hashPart = '';
  
  if (hashIndex > -1) {
    const beforeHash = fullUrl.substring(0, hashIndex);
    hashPart = fullUrl.substring(hashIndex);
    
    const searchIndex = beforeHash.indexOf('?');
    if (searchIndex > -1) {
      searchPart = beforeHash.substring(searchIndex + 1);
    }
    
    if (hashPart.indexOf('?') > -1) {
      const hashQueryString = hashPart.split('?')[1];
      if (hashQueryString) {
        const params = new URLSearchParams(hashQueryString);
        const value = params.get(name);
        if (value !== null) {
          return decodeURIComponent(value);
        }
      }
    }
    
    if (hashPart.indexOf('&') > -1 && searchPart) {
      const combinedParams = searchPart + '&' + hashPart.substring(1);
      const params = new URLSearchParams(combinedParams);
      const value = params.get(name);
      if (value !== null) {
        return decodeURIComponent(value);
      }
    }
  } else {
    const searchIndex = fullUrl.indexOf('?');
    if (searchIndex > -1) {
      searchPart = fullUrl.substring(searchIndex + 1);
    }
  }
  
  if (searchPart) {
    const params = new URLSearchParams(searchPart);
    const value = params.get(name);
    if (value !== null) {
      return decodeURIComponent(value);
    }
  }
  
  return null;
};

export const getQueryParam = (paramName) => {
  const fullUrl = window.location.href;
  const hashIndex = fullUrl.indexOf('#');
  
  if (hashIndex > -1) {
    const beforeHash = fullUrl.substring(0, hashIndex);
    try {
      const urlObj = new URL(beforeHash);
      const paramValue = urlObj.searchParams.get(paramName);
      if (paramValue !== null) {
        return decodeURIComponent(paramValue);
      }
    } catch (e) {
      const searchIndex = beforeHash.indexOf('?');
      if (searchIndex > -1) {
        const searchPart = beforeHash.substring(searchIndex + 1);
        const params = new URLSearchParams(searchPart);
        const value = params.get(paramName);
        if (value !== null) {
          return decodeURIComponent(value);
        }
      }
    }
    
    const hashPart = fullUrl.substring(hashIndex);
    if (hashPart.indexOf('?') > -1) {
      const hashQueryString = hashPart.split('?')[1];
      if (hashQueryString) {
        const params = new URLSearchParams(hashQueryString);
        const value = params.get(paramName);
        if (value !== null) {
          return decodeURIComponent(value);
        }
      }
    }
    
    if (hashPart.indexOf('&') > -1) {
      const searchIndex = beforeHash.indexOf('?');
      if (searchIndex > -1) {
        const searchPart = beforeHash.substring(searchIndex + 1);
        const combinedParams = searchPart + '&' + hashPart.substring(1);
        const params = new URLSearchParams(combinedParams);
        const value = params.get(paramName);
        if (value !== null) {
          return decodeURIComponent(value);
        }
      }
    }
  } else {
    try {
      const urlObj = new URL(fullUrl);
      const paramValue = urlObj.searchParams.get(paramName);
      if (paramValue !== null) {
        return decodeURIComponent(paramValue);
      }
    } catch (e) {
      const searchIndex = fullUrl.indexOf('?');
      if (searchIndex > -1) {
        const searchPart = fullUrl.substring(searchIndex + 1);
        const params = new URLSearchParams(searchPart);
        const value = params.get(paramName);
        if (value !== null) {
          return decodeURIComponent(value);
        }
      }
    }
  }
  
  return null;
};



// WEBPACK FOOTER //
// ./src/util/extends/cookieExpand.js